/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, BoxProps, Stack, Typography, styled } from "@mui/material";
import { FC, PropsWithChildren } from "react";

export interface DisplayItemNodeProps extends PropsWithChildren {
  /** Title */
  title: string;
  boxProps?: BoxProps;
}

export const DisplayItemNodeValue = styled(Typography)(({ theme }) => ({
  lineHeight: 1,
  marginTop: "-0.3rem",
  paddingLeft: "1rem",
  paddingBottom: "0.3rem",
  wordBreak: "break-word",
}));

/**
 * Component of item display
 * @param {Props} param0 Properties
 * @return {FC} Component
 */
export const DisplayItemNode: FC<DisplayItemNodeProps> = ({
  title,
  children,
  boxProps,
}) => {
  return (
    <Box {...boxProps}>
      <Stack>
        <Typography variant="subtitle1">{title}:</Typography>
        <Box
          sx={{
            marginTop: "-0.3rem",
            // paddingTop: "0.25rem",
            paddingLeft: "1rem",
            paddingBottom: "0.3rem",
          }}
        >
          {children}
        </Box>
      </Stack>
    </Box>
  );
};
